export const repairType = state => state.repairType;
